import ContractAttachmentsActionRequired from './ContractAttachmentsActionRequired';

export default ContractAttachmentsActionRequired;
